(function () {
	const initProductAccordion = () => {
		if (typeof window.jQuery === "undefined") return;

		const $ = window.jQuery;

		// Event delegation so clicks keep working after variant popup open/close
		// (focus-trap races / DOM updates must not leave toggles unbound).
		if (!document.documentElement.dataset.productAccordionDelegated) {
			document.documentElement.dataset.productAccordionDelegated = "true";

			$(document).on("click", ".about__accordion-toggle", function (e) {
				e.preventDefault();

				const currentToggle = $(this);
				const siblingDescription = currentToggle.siblings(
					".about__accordion-description"
				);
				const allToggles = $(".about__accordion-toggle");

				if (!currentToggle.hasClass("active")) {
					allToggles.each(function () {
						const siblingToggle = $(this);
						siblingToggle.removeClass("active");
						siblingToggle
							.siblings(".about__accordion-description")
							.stop(true, true)
							.slideUp(300);
					});

					currentToggle.addClass("active");
					siblingDescription.stop(true, true).slideDown(300);
				} else {
					currentToggle.removeClass("active");
					siblingDescription.stop(true, true).slideUp(300);
				}
			});
		}
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		const images =
			imagesWrapper && imagesWrapper.querySelectorAll(".js-image-zoom")
				? imagesWrapper.querySelectorAll(".js-image-zoom")
				: [];

		Array.prototype.forEach.call(images, function (el) {
			if (el.dataset.zoomInit === "true") return;
			el.dataset.zoomInit = "true";
			el.addEventListener("click", function () {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const formatFreeShippingAmount = (value) => {
		const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
		const formatString = theme.moneyFormat;

		return formatString.replace(placeholderRegex, value);
	};

	const setTotalFreeShipping = () => {
		if (document.querySelector(".js-free-shipping")) {
			const freeShippingTotal = document.querySelector(".free-shipping-total");
			if (freeShippingTotal) {
				const minSpend = Number(freeShippingTotal.dataset.minSpend);
				if (minSpend && minSpend > 0) {
					freeShippingTotal.innerText = `${formatFreeShippingAmount(
						Math.round(minSpend * (Shopify.currency.rate || 1))
					)}`;
				}
			}
		}
	};

	const revealPopup = () => {
		const stickyBar = document.querySelector(".floated_form");
		const secondSection = document.querySelector(".product-section + section");
		const footer = document.querySelector("footer");

		const button = document.querySelector(".floated_form-button");
		if (button && button.dataset.floatedScrollInit !== "true") {
			button.dataset.floatedScrollInit = "true";
			button.addEventListener("click", function () {
				window.scrollTo(0, 0);
			});
		}

		if (!stickyBar || !secondSection || !footer) {
			return;
		}

		const getOffset = (element) => {
			const rect = element.getBoundingClientRect();
			return rect.top + window.scrollY;
		};

		const secondSectionMid = getOffset(secondSection);
		const footerTop = getOffset(footer);

		const handleScroll = () => {
			const scrollPosition = window.scrollY + window.innerHeight;
			const activeOffset =
				window.scrollY > secondSectionMid && scrollPosition < footerTop;

			stickyBar.classList[activeOffset ? "add" : "remove"]("active");
		};

		handleScroll();
	};

	document.addEventListener("scroll", function () {
		revealPopup();
	});

	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		setTotalFreeShipping();
		revealPopup();
	});

	// After variant popup closes, clear any leftover focus trap / body lock
	document.body.addEventListener("modalClosed", function () {
		document.body.classList.remove("overflow-hidden");
	});

	initProductAccordion();
	initZoomImage();
	setTotalFreeShipping();
	revealPopup();
})();
